import { useEffect, useState } from 'react';
import StatusEnum from 'axios/enum';
import { MethodEnum } from 'axios/type';
import useAxios from 'axios/useAxios';
import { option2Trans } from 'tradevan-ui/consts';
import { Ioption } from 'tradevan-ui/type';

interface IuseQuerySupplierCodeListDetail extends Ioption {
  value: string;
  text: string;
}

interface IquerySupplierCodeListResponse extends Ioption {
  contents: IuseQuerySupplierCodeListDetail[];
}

/** 廠編 選單OpTrs */
const useSupplierCodeListOpTrs = (retailerId: string) => {
  const [option, setOption] = useState<IuseQuerySupplierCodeListDetail[]>([]);
  const axios = useAxios();
  useEffect(() => {
    if (retailerId) {
      (async () => {
        const response = await axios.doAxios<
          unknown,
          IquerySupplierCodeListResponse
        >(MethodEnum.post, 'common/querySupplierCodeList', {
          retailerId,
        });
        if (response && response.data.status === StatusEnum.完成) {
          setOption(
            response.data.data.contents.map((obj) => ({
              ...obj,
              value: obj.value,
              label: obj.text,
            })),
          );
        }
      })();
    }
  }, [retailerId]);
  return option2Trans(option);
};

export default useSupplierCodeListOpTrs;
